export class DateServiceError extends Error {
  constructor(
    message: string,
    public readonly code: string
  ) {
    super(message);
    this.name = 'DateServiceError';
  }
}

export class DateParsingError extends DateServiceError {
  constructor(message: string) {
    super(message, 'DATE_PARSING_ERROR');
    this.name = 'DateParsingError';
  }
}

export class DateValidationError extends DateServiceError {
  constructor(message: string) {
    super(message, 'DATE_VALIDATION_ERROR');
    this.name = 'DateValidationError';
  }
}

export class DateRangeError extends DateServiceError {
  constructor(message: string) {
    super(message, 'DATE_RANGE_ERROR');
    this.name = 'DateRangeError';
  }
}
